// Mock data for EZLOAD - India logistics platform

export const currentUser = {
  id: 'u_001',
  name: 'Rajesh Kumar',
  company: 'Kumar Transports Pvt. Ltd.',
  role: 'Fleet Owner',
  phone: '+91 98765 43210',
  email: 'rajesh@kumartransports.in',
  gstin: '27AABCU9603R1ZM',
  city: 'Mumbai',
  state: 'Maharashtra',
  avatar: 'RK',
  verified: true,
  subscription: {
    plan: 'Free Trial',
    daysLeft: 22,
    renewsOn: '2025-08-28',
    priceMonthly: 500,
    gst: 90,
  }
};

export const indianCities = [
  'Mumbai, MH', 'Delhi, DL', 'Bengaluru, KA', 'Chennai, TN', 'Kolkata, WB',
  'Hyderabad, TS', 'Ahmedabad, GJ', 'Pune, MH', 'Surat, GJ', 'Jaipur, RJ',
  'Lucknow, UP', 'Kanpur, UP', 'Nagpur, MH', 'Indore, MP', 'Bhopal, MP',
  'Coimbatore, TN', 'Vadodara, GJ', 'Ludhiana, PB', 'Agra, UP', 'Nashik, MH',
  'Faridabad, HR', 'Meerut, UP', 'Rajkot, GJ', 'Kalyan, MH', 'Vasai, MH',
  'Varanasi, UP', 'Srinagar, JK', 'Aurangabad, MH', 'Dhanbad, JH', 'Amritsar, PB',
  'Navi Mumbai, MH', 'Allahabad, UP', 'Ranchi, JH', 'Howrah, WB', 'Jabalpur, MP',
  'Gwalior, MP', 'Vijayawada, AP', 'Jodhpur, RJ', 'Madurai, TN', 'Raipur, CG',
  'Kota, RJ', 'Guwahati, AS', 'Chandigarh, CH', 'Thiruvananthapuram, KL', 'Kochi, KL',
  'Bhubaneswar, OD', 'Mysore, KA', 'Tiruchirappalli, TN', 'Hubli, KA', 'Mangalore, KA'
];

export const truckTypes = [
  { code: 'TR-32', label: '32ft Multi Axle (SXL)', capacity: '18-20 T' },
  { code: 'TR-24', label: '24ft Container', capacity: '9-10 T' },
  { code: 'TR-22', label: '22ft Open Body', capacity: '10-12 T' },
  { code: 'TR-20', label: '20ft Container', capacity: '7-8 T' },
  { code: 'TR-19', label: '19ft Truck', capacity: '7-8 T' },
  { code: 'TR-17', label: '17ft Truck', capacity: '5-6 T' },
  { code: 'TR-14', label: '14ft Truck', capacity: '3.5-4 T' },
  { code: 'TR-TA', label: 'Tanker', capacity: 'Liquid' },
  { code: 'TR-TR', label: 'Trailer 40ft', capacity: '25-30 T' },
  { code: 'TR-RE', label: 'Refrigerated', capacity: '5-15 T' },
  { code: 'TR-TP', label: 'Tipper', capacity: '10-25 T' },
  { code: 'TR-LC', label: 'LCV (Tata Ace/Bolero)', capacity: '0.5-1.5 T' },
];

export const materialTypes = [
  'Cement', 'Steel & TMT Bars', 'Textiles & Garments', 'FMCG Goods',
  'Electronics', 'Agricultural Produce', 'Automobile Parts', 'Chemicals',
  'Pharmaceuticals', 'Food Grains', 'Cotton Bales', 'Furniture',
  'Machinery', 'Plastic Goods', 'Paper & Pulp', 'Fresh Produce (Reefer)',
  'Petroleum Products', 'Milk & Dairy', 'Sugar', 'Rice & Wheat'
];

const rand = (arr) => arr[Math.floor(Math.random() * arr.length)];
const randInt = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;

const companies = [
  'Sharma Logistics', 'Patel Transports', 'BlueDart Cargo', 'Reliance Freight',
  'Om Sai Roadlines', 'Bharat Movers', 'Ganesh Transport Co.', 'Shree Krishna Carriers',
  'VRL Logistics', 'Safexpress', 'Delhivery Freight', 'Gati-KWE',
  'AllCargo Logistics', 'TCI Freight', 'Rivigo Express', 'Mahindra Logistics',
];

const names = [
  'Amit Verma', 'Suresh Reddy', 'Priya Nair', 'Vikram Singh', 'Anjali Desai',
  'Rohan Mehta', 'Deepak Yadav', 'Kavita Rao', 'Manoj Pillai', 'Ritu Sharma',
  'Sanjay Gupta', 'Neha Kapoor', 'Arjun Iyer', 'Pooja Joshi', 'Karan Chawla'
];

export const generateLoads = (count = 30) => {
  const loads = [];
  for (let i = 0; i < count; i++) {
    const origin = rand(indianCities);
    let dest = rand(indianCities);
    while (dest === origin) dest = rand(indianCities);
    const truck = rand(truckTypes);
    const weight = randInt(3, 30);
    const rate = randInt(15000, 180000);
    loads.push({
      id: `LD${1000 + i}`,
      origin,
      destination: dest,
      pickupDate: new Date(Date.now() + randInt(0, 5) * 86400000).toISOString(),
      material: rand(materialTypes),
      weight: `${weight} T`,
      truckType: truck.label,
      truckCode: truck.code,
      rate,
      distance: randInt(300, 2200),
      poster: rand(companies),
      posterContact: rand(names),
      posterPhone: `+91 9${randInt(100000000, 999999999)}`,
      posterRating: (Math.random() * 1.5 + 3.5).toFixed(1),
      verified: Math.random() > 0.3,
      postedMinutesAgo: randInt(1, 720),
      paymentTerms: rand(['Advance 30%', 'Advance 50%', 'On Delivery (COD)', 'Credit 15 days', 'Credit 30 days']),
      status: 'open',
    });
  }
  return loads;
};

export const generateTrucks = (count = 25) => {
  const trucks = [];
  const statuses = ['Available Now', 'Available Tomorrow', 'Available in 2 days'];
  for (let i = 0; i < count; i++) {
    const currentLoc = rand(indianCities);
    let goingTo = rand(indianCities);
    while (goingTo === currentLoc) goingTo = rand(indianCities);
    const truck = rand(truckTypes);
    trucks.push({
      id: `TR${2000 + i}`,
      currentLocation: currentLoc,
      preferredDestination: goingTo,
      truckType: truck.label,
      truckCode: truck.code,
      capacity: truck.capacity,
      vehicleNumber: `${rand(['MH','GJ','DL','KA','TN','UP','RJ'])} ${randInt(10,99)} ${['AB','CD','EF','GH'][randInt(0,3)]} ${randInt(1000,9999)}`,
      owner: rand(companies),
      ownerContact: rand(names),
      ownerPhone: `+91 9${randInt(100000000, 999999999)}`,
      rating: (Math.random() * 1.5 + 3.5).toFixed(1),
      verified: Math.random() > 0.25,
      availability: rand(statuses),
      expectedRate: randInt(20000, 150000),
      postedMinutesAgo: randInt(1, 480),
    });
  }
  return trucks;
};

export const myLoads = [
  { id: 'LD9001', origin: 'Mumbai, MH', destination: 'Delhi, DL', material: 'Textiles & Garments', weight: '18 T', truckType: '32ft Multi Axle', rate: 85000, status: 'In Transit', driver: 'Sohan Lal', driverPhone: '+91 98123 45678', vehicleNumber: 'MH 12 AB 3456', progress: 65, pickupDate: '2025-07-05', expectedDelivery: '2025-07-08', paymentStatus: 'Advance Paid', paymentTerms: 'Advance 30%' },
  { id: 'LD9002', origin: 'Bengaluru, KA', destination: 'Chennai, TN', material: 'Electronics', weight: '8 T', truckType: '20ft Container', rate: 32000, status: 'Delivered', driver: 'Ramesh N', driverPhone: '+91 90123 56789', vehicleNumber: 'KA 05 CD 7890', progress: 100, pickupDate: '2025-07-01', expectedDelivery: '2025-07-02', paymentStatus: 'Paid', paymentTerms: 'On Delivery' },
  { id: 'LD9003', origin: 'Ahmedabad, GJ', destination: 'Pune, MH', material: 'Cement', weight: '25 T', truckType: 'Trailer 40ft', rate: 62000, status: 'Loading', driver: 'Bhavesh P', driverPhone: '+91 99876 54321', vehicleNumber: 'GJ 01 EF 1234', progress: 15, pickupDate: '2025-07-07', expectedDelivery: '2025-07-09', paymentStatus: 'Pending', paymentTerms: 'Advance 50%' },
  { id: 'LD9004', origin: 'Hyderabad, TS', destination: 'Kolkata, WB', material: 'Pharmaceuticals', weight: '6 T', truckType: '19ft Truck', rate: 78000, status: 'Assigned', driver: 'Praveen K', driverPhone: '+91 90000 11111', vehicleNumber: 'TS 09 GH 5678', progress: 0, pickupDate: '2025-07-08', expectedDelivery: '2025-07-11', paymentStatus: 'Pending', paymentTerms: 'Credit 15 days' },
];

export const dashboardStats = {
  activeLoads: 12,
  availableTrucks: 47,
  monthlyRevenue: 428500,
  completedTrips: 34,
  pendingPayments: 65000,
  savedRoutes: 8,
  avgRatePerKm: 42,
  onTimeDelivery: 94,
};

export const laneInsights = [
  { lane: 'Mumbai → Delhi', avgRate: 82000, ratePerKm: 58, distance: 1420, volume: 'High', trend: 'up', change: 4.2 },
  { lane: 'Bengaluru → Chennai', avgRate: 32000, ratePerKm: 91, distance: 350, volume: 'Very High', trend: 'up', change: 2.1 },
  { lane: 'Delhi → Kolkata', avgRate: 92000, ratePerKm: 62, distance: 1490, volume: 'Medium', trend: 'down', change: -1.8 },
  { lane: 'Ahmedabad → Mumbai', avgRate: 28000, ratePerKm: 54, distance: 520, volume: 'High', trend: 'up', change: 3.5 },
  { lane: 'Chennai → Hyderabad', avgRate: 42000, ratePerKm: 65, distance: 640, volume: 'Medium', trend: 'flat', change: 0.4 },
  { lane: 'Pune → Nagpur', avgRate: 38000, ratePerKm: 51, distance: 750, volume: 'Medium', trend: 'up', change: 1.9 },
  { lane: 'Delhi → Jaipur', avgRate: 22000, ratePerKm: 78, distance: 280, volume: 'Very High', trend: 'up', change: 5.1 },
  { lane: 'Kolkata → Guwahati', avgRate: 55000, ratePerKm: 55, distance: 1000, volume: 'Low', trend: 'down', change: -2.3 },
];

export const rateChartData = [
  { month: 'Feb', mum_del: 76000, bng_che: 30000, ahm_mum: 26000 },
  { month: 'Mar', mum_del: 78000, bng_che: 30500, ahm_mum: 27000 },
  { month: 'Apr', mum_del: 80000, bng_che: 31200, ahm_mum: 27500 },
  { month: 'May', mum_del: 79000, bng_che: 31800, ahm_mum: 28000 },
  { month: 'Jun', mum_del: 81500, bng_che: 32000, ahm_mum: 28500 },
  { month: 'Jul', mum_del: 82000, bng_che: 32000, ahm_mum: 28000 },
];

export const documents = [
  { id: 'DOC001', type: 'e-LR (Lorry Receipt)', loadId: 'LD9001', from: 'Mumbai', to: 'Delhi', date: '2025-07-05', status: 'Generated', amount: 85000 },
  { id: 'DOC002', type: 'e-Way Bill', loadId: 'LD9001', from: 'Mumbai', to: 'Delhi', date: '2025-07-05', status: 'Active', amount: 85000, ewbNumber: '741852963012' },
  { id: 'DOC003', type: 'Invoice', loadId: 'LD9002', from: 'Bengaluru', to: 'Chennai', date: '2025-07-02', status: 'Paid', amount: 32000, invoiceNumber: 'INV/2025/0102' },
  { id: 'DOC004', type: 'e-LR (Lorry Receipt)', loadId: 'LD9003', from: 'Ahmedabad', to: 'Pune', date: '2025-07-07', status: 'Pending', amount: 62000 },
  { id: 'DOC005', type: 'PoD (Proof of Delivery)', loadId: 'LD9002', from: 'Bengaluru', to: 'Chennai', date: '2025-07-02', status: 'Signed', amount: 32000 },
  { id: 'DOC006', type: 'Invoice', loadId: 'LD9001', from: 'Mumbai', to: 'Delhi', date: '2025-07-05', status: 'Pending', amount: 85000, invoiceNumber: 'INV/2025/0103' },
];

export const transactions = [
  { id: 'TXN001', type: 'received', method: 'UPI', from: 'Kumar Traders', amount: 45000, date: '2025-07-06', status: 'success', ref: 'UPI/523698741' },
  { id: 'TXN002', type: 'paid', method: 'NetBanking', to: 'Sohan Lal (Driver)', amount: 12000, date: '2025-07-06', status: 'success', ref: 'NEFT/N123456' },
  { id: 'TXN003', type: 'received', method: 'RTGS', from: 'Reliance Freight', amount: 128000, date: '2025-07-05', status: 'success', ref: 'RTGS/UTIB4523' },
  { id: 'TXN004', type: 'paid', method: 'Card', to: 'HP Petrol Pump', amount: 8500, date: '2025-07-05', status: 'success', ref: 'CARD/****4521' },
  { id: 'TXN005', type: 'received', method: 'COD', from: 'Sharma Logistics', amount: 32000, date: '2025-07-02', status: 'success', ref: 'COD/CASH' },
  { id: 'TXN006', type: 'paid', method: 'UPI', to: 'FASTag Recharge', amount: 5000, date: '2025-07-01', status: 'success', ref: 'UPI/632147852' },
];

export const walletBalance = {
  available: 148500,
  pending: 65000,
  monthReceived: 428500,
  monthPaid: 156000,
};

export const testimonials = [
  { name: 'Ravi Sharma', role: 'Fleet Owner, 45 Trucks', company: 'Sharma Roadlines, Delhi', quote: 'EZLOAD ne mera business badha diya. Ab empty trucks nahi rehte, har trip me return load milta hai.', rating: 5, avatar: 'RS' },
  { name: 'Priya Menon', role: 'Logistics Manager', company: 'Menon Exports, Kochi', quote: 'The transparent rate insights help me negotiate better. Payment via UPI is instant — no more waiting for cheques.', rating: 5, avatar: 'PM' },
  { name: 'Harpreet Singh', role: 'Truck Owner', company: 'Punjab Carriers, Ludhiana', quote: 'Verified shippers, timely payment, aur GST compliant e-LR — sab kuch ek jagah. Best decision for my transport business.', rating: 5, avatar: 'HS' },
];

export const featuresIndia = [
  { icon: 'Truck', title: 'India-Wide Load Board', desc: 'Live loads across 500+ Indian cities — Mumbai to Guwahati, Chennai to Srinagar. Post or find in seconds.' },
  { icon: 'MapPin', title: 'Truck Board & Lane Match', desc: 'Post your empty truck, get matched with shippers on your return route. Zero empty miles.' },
  { icon: 'FileText', title: 'e-LR & e-Way Bill Ready', desc: 'GST-compliant Lorry Receipt, e-Way Bill generation, and digital PoD — all in one dashboard.' },
  { icon: 'IndianRupee', title: 'UPI, RTGS & COD Payments', desc: 'Instant UPI settlements, RTGS/NEFT for large amounts, COD for POD freight. Fully secure & GST-invoiced.' },
  { icon: 'BarChart3', title: 'Lane Rate Insights', desc: 'Real-time rate trends per km across 100+ Indian corridors. Negotiate with confidence.' },
  { icon: 'ShieldCheck', title: 'Verified Partners Only', desc: 'GSTIN + PAN + Aadhaar verified shippers and transporters. Zero fraud, guaranteed payment protection.' },
];

export const notifications = [
  { id: 1, type: 'load', title: 'New load matching your route', desc: 'Mumbai → Delhi, 18T Textiles, ₹85,000', time: '5 min ago', unread: true },
  { id: 2, type: 'payment', title: 'Payment received', desc: '₹45,000 via UPI from Kumar Traders', time: '1 hour ago', unread: true },
  { id: 3, type: 'trip', title: 'Trip LD9001 in transit', desc: 'Vehicle MH 12 AB 3456 crossed Nashik', time: '3 hours ago', unread: false },
  { id: 4, type: 'document', title: 'e-Way Bill generated', desc: 'EWB #741852963012 for LD9001', time: '5 hours ago', unread: false },
  { id: 5, type: 'subscription', title: 'Trial ends in 22 days', desc: 'Upgrade to Pro at ₹500 + GST/month', time: '1 day ago', unread: false },
];
